var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import CrossIcon from '../atoms/CrossIcon';
import AccordionArrow from '../atoms/AccordionArrow';
import { getAvailableCurrencies, getMoneyFormat, formatCurrency } from '../../helpers/currencies';
import LockedIcon from '../atoms/LockedIcon';
import UnlockedIcon from '../atoms/UnlockedIcon';
const AddToCartModal = ({ strings, settings, previewImage, modalOpen, variants, isoCode, cartState, templateCopy, updateCartState, closeModal, addToCart, openSizeGuideModal, }) => {
    const [price, setPrice] = useState({ beforeDiscount: '-', finalPrice: '-' });
    const [accordionOpen, setAccordionOpen] = useState(true);
    const [quantityInCart, setQuantity] = useState(0);
    const formatPrice = (combinedPrices, discountAmount) => __awaiter(void 0, void 0, void 0, function* () {
        return yield getAvailableCurrencies().then((currencies) => {
            const selectedCountry = currencies.availableCountries.filter((country) => country.isoCode === isoCode)[0];
            const moneyFormat = getMoneyFormat(selectedCountry);
            const money = formatCurrency(combinedPrices, moneyFormat);
            const discountCost = combinedPrices * (discountAmount / 100);
            const withDiscount = combinedPrices - discountCost;
            const final = formatCurrency(withDiscount, moneyFormat);
            setPrice({
                finalPrice: final,
                beforeDiscount: money,
            });
        });
    });
    const fetchCart = () => {
        fetch('/cart.js')
            .then((response) => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
            .then((cart) => {
            // console.log('cart', cart);
            let totalCustomisableCount = 0;
            cart.items.forEach((item) => {
                if (item.properties && item.properties._th_customiser) {
                    totalCustomisableCount += item.quantity;
                }
            });
            SetCustomisableProductsInCart(totalCustomisableCount);
        })
            .catch((error) => {
            console.error('Error fetching cart:', error);
        });
    };
    fetchCart();
    // Tiered Discounts
    const [totalCustomisableProductCount, SetTotalCustomisableProductCount] = useState(0);
    const [customisableProductsInCart, SetCustomisableProductsInCart] = useState(0);
    useEffect(() => {
        if (cartState.length) {
            const combinedPrices = cartState.reduce((acc, obj) => {
                const [currentVariant] = variants.filter((variant) => variant.id == obj.id);
                if (currentVariant) {
                    const variantPrice = obj.quantity * currentVariant.price;
                    return acc + variantPrice;
                }
            }, 0);
            const combinedQty = cartState.reduce((acc, obj) => {
                return acc + obj.quantity;
            }, 0);
            setQuantity(combinedQty);
            if (settings.enable_discount) {
                if (settings.tier_three_enable && totalCustomisableProductCount >= settings.tier_three_qty) {
                    formatPrice(combinedPrices, settings.tier_three_disc);
                }
                else if (settings.tier_two_enable && totalCustomisableProductCount >= settings.tier_two_qty) {
                    formatPrice(combinedPrices, settings.tier_two_disc);
                }
                else if (totalCustomisableProductCount >= settings.tier_one_qty) {
                    formatPrice(combinedPrices, settings.tier_one_disc);
                }
                else {
                    formatPrice(combinedPrices, 0);
                }
            }
            else {
                formatPrice(combinedPrices, 0);
            }
        }
    }, [cartState, totalCustomisableProductCount]);
    // Tiered Discounts
    useEffect(() => {
        if (cartState.length) {
            SetTotalCustomisableProductCount(customisableProductsInCart + quantityInCart);
        }
        else {
            SetTotalCustomisableProductCount(customisableProductsInCart);
        }
    }, [cartState, customisableProductsInCart, quantityInCart]);
    return (React.createElement("div", { className: `th-c-atc-modal ${modalOpen ? 'open' : ''}` },
        React.createElement("div", { className: "th-c-atc-modal__background", onClick: closeModal }),
        React.createElement("div", { className: "th-c-atc-modal__inner" },
            React.createElement("div", { className: "th-c-atc-modal__header" },
                React.createElement("h3", { className: "th-customiser__section-title" }, strings.modal_title),
                React.createElement("button", { className: "th-c-atc-modal__close", "aria-label": "close", onClick: closeModal },
                    React.createElement(CrossIcon, null))),
            React.createElement("div", { className: "th-c-atc-modal__main" },
                previewImage ? (React.createElement("img", { className: "th-c-atc-modal__main--preview-image", src: previewImage })) : (React.createElement("div", { className: "th-c-atc-modal__main--image-placeholder" },
                    React.createElement("h3", null, "Loading your preview"))),
                React.createElement("div", { className: "th-c-atc-modal__footer" },
                    React.createElement("div", { className: "th-c-atc-modal__accordion" },
                        React.createElement("input", { type: "checkbox", name: "accordion", id: "th-c-quantity", checked: accordionOpen, onChange: () => setAccordionOpen(!accordionOpen) }),
                        React.createElement("label", { htmlFor: "th-c-quantity", className: "th-c-atc-modal__accordion--label th-customiser__section-title" },
                            templateCopy.th_c_modal_size_title,
                            React.createElement(AccordionArrow, null)),
                        templateCopy.th_c_size_guide_content != null && (React.createElement("div", { className: "th-c-size-guide-toggle", onClick: openSizeGuideModal },
                            templateCopy.th_c_size_guide_button,
                            React.createElement("span", { dangerouslySetInnerHTML: { __html: templateCopy.th_c_size_guide_icon } }))),
                        React.createElement("div", { className: "th-c-atc-modal__accordion--content" },
                            settings.enable_discount && (React.createElement("div", { className: "th-c-atc-modal__discount-message" },
                                React.createElement("div", { className: cartState.length > 0
                                        ? `th-c-atc-modal__discount-message--prices`
                                        : `th-c-atc-modal__discount-message--prices-hidden` },
                                    React.createElement("span", { className: "text-subdued" },
                                        "(",
                                        quantityInCart,
                                        " ",
                                        quantityInCart > 1 ? `Items` : `Item`,
                                        ")"),
                                    React.createElement("span", { className: "th-c-atc-modal__discount-message--final-price" }, price.finalPrice),
                                    totalCustomisableProductCount >= settings.tier_one_qty ? (React.createElement("span", { className: "th-c-atc-modal__discount-message--original-price" }, price.beforeDiscount)) : null,
                                    settings.tier_three_enable && totalCustomisableProductCount >= settings.tier_three_qty ? (React.createElement("div", { className: "th-c-atc-modal__discount-message--badge" },
                                        "Save ",
                                        settings.tier_three_disc,
                                        "%")) : settings.tier_two_enable && totalCustomisableProductCount >= settings.tier_two_qty ? (React.createElement("div", { className: "th-c-atc-modal__discount-message--badge" },
                                        "Save ",
                                        settings.tier_two_disc,
                                        "%")) : settings.enable_discount && totalCustomisableProductCount >= settings.tier_one_qty ? (React.createElement("div", { className: "th-c-atc-modal__discount-message--badge" },
                                        "Save ",
                                        settings.tier_one_disc,
                                        "%")) : null))),
                            React.createElement("div", { className: `th-c-atc-modal__quantity ${variants.length == 1 ? 'default-variant' : ''}` }, variants.map((variant, index) => {
                                const [inCart] = cartState.filter((cartItem) => cartItem.id == variant.id);
                                return (React.createElement("div", { key: `th-c-quantity--${index}`, className: `th-c-atc-modal__quantity--input ${inCart ? 'selected' : ''}${!variant.available ? 'oos' : ''}` },
                                    variant.option2 ? React.createElement("h5", null, variant.option2) : null,
                                    React.createElement("div", { className: `th-c-quantity-selector` },
                                        React.createElement("button", { type: "button", className: "decrement-quantity", "aria-label": "Subtract one", "data-direction": "-1", disabled: !variant.available, onClick: () => updateCartState(variant.id, -1) },
                                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "2", viewBox: "0 0 10 2", fill: "none" },
                                                React.createElement("path", { d: "M0 0H10V2H0V0Z", fill: "black" }))),
                                        React.createElement("input", { "data-min": "1", "data-max": "0", type: "text", name: "quantity", value: inCart ? inCart.quantity : 0, readOnly: true, onChange: (e) => updateCartState(variant.id, Number(e.target.value)) }),
                                        React.createElement("button", { type: "button", className: "increment-quantity", "aria-label": "Add one", "data-direction": "1", disabled: !variant.available, onClick: () => updateCartState(variant.id, 1) },
                                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10", viewBox: "0 0 10 10", fill: "none" },
                                                React.createElement("path", { d: "M4.16667 5.83333V10H5.83333V5.83333H10V4.16667H5.83333V0H4.16667V4.16667H0V5.83333H4.16667Z", fill: "black" }))))));
                            }))))),
                settings.enable_discount && (React.createElement("div", { className: "th-c-atc-modal__discount-bar" },
                    customisableProductsInCart > 0 ? (React.createElement("p", { className: "text-sm text-subdued" },
                        "You already have ",
                        customisableProductsInCart,
                        " customised",
                        ' ',
                        customisableProductsInCart == 1 ? 'product' : 'products',
                        " in your cart.")) : null,
                    React.createElement("div", { style: { display: 'none' } },
                        "totalCustomisableProductCount (TEMP): ",
                        totalCustomisableProductCount),
                    React.createElement("div", { className: "discount-bar__message" },
                        settings.tier_three_enable && totalCustomisableProductCount >= settings.tier_three_qty ? (React.createElement("span", null,
                            "You're saving ",
                            React.createElement("strong", null,
                                settings.tier_three_disc,
                                "%"))) : settings.tier_two_enable && totalCustomisableProductCount >= settings.tier_two_qty ? (React.createElement("span", null,
                            "You're saving ",
                            React.createElement("strong", null,
                                settings.tier_two_disc,
                                "%"))) : settings.enable_discount && totalCustomisableProductCount >= settings.tier_one_qty ? (React.createElement("span", null,
                            "You're saving ",
                            React.createElement("strong", null,
                                settings.tier_one_disc,
                                "%"))) : null,
                        settings.enable_discount && totalCustomisableProductCount < settings.tier_one_qty ? (React.createElement("span", null,
                            "Add ",
                            React.createElement("strong", null, settings.tier_one_qty - totalCustomisableProductCount),
                            " to",
                            ' ',
                            React.createElement("strong", null,
                                "Save ",
                                settings.tier_one_disc,
                                "%"))) : null,
                        settings.tier_two_enable &&
                            totalCustomisableProductCount >= settings.tier_one_qty &&
                            totalCustomisableProductCount < settings.tier_two_qty ? (React.createElement("span", null,
                            "Add ",
                            React.createElement("strong", null, settings.tier_two_qty - totalCustomisableProductCount),
                            " more to",
                            ' ',
                            React.createElement("strong", null,
                                "Save ",
                                settings.tier_two_disc,
                                "%"))) : null,
                        settings.tier_three_enable &&
                            totalCustomisableProductCount >= settings.tier_two_qty &&
                            totalCustomisableProductCount < settings.tier_three_qty ? (React.createElement("span", null,
                            "Add ",
                            React.createElement("strong", null, settings.tier_three_qty - totalCustomisableProductCount),
                            " more to",
                            ' ',
                            React.createElement("strong", null,
                                "Save ",
                                settings.tier_three_disc,
                                "%"))) : null),
                    React.createElement("div", { className: "discount-bar__tiers" },
                        settings.tier_one_disc && settings.tier_one_qty ? (React.createElement("div", { className: "discount-bar__tier discount-bar__tier--one", style: {
                                '--steps': settings.tier_one_qty,
                                '--required': totalCustomisableProductCount < settings.tier_one_qty
                                    ? settings.tier_one_qty - totalCustomisableProductCount
                                    : settings.tier_one_qty - totalCustomisableProductCount <= 0
                                        ? 0
                                        : settings.tier_one_qty - totalCustomisableProductCount,
                            } })) : null,
                        settings.tier_two_enable ? (React.createElement("div", { className: "discount-bar__tier discount-bar__tier--two", style: {
                                '--steps': settings.tier_two_qty - settings.tier_one_qty,
                                '--required': totalCustomisableProductCount > settings.tier_one_qty
                                    ? settings.tier_two_qty - totalCustomisableProductCount >= 0
                                        ? settings.tier_two_qty - totalCustomisableProductCount
                                        : 0
                                    : settings.tier_two_qty - settings.tier_one_qty,
                            } })) : null,
                        settings.tier_three_enable ? (React.createElement("div", { className: "discount-bar__tier discount-bar__tier--three", style: {
                                '--steps': settings.tier_three_qty - settings.tier_two_qty,
                                '--required': totalCustomisableProductCount > settings.tier_two_qty
                                    ? settings.tier_three_qty - totalCustomisableProductCount >= 0
                                        ? settings.tier_three_qty - totalCustomisableProductCount
                                        : 0
                                    : settings.tier_three_qty - settings.tier_two_qty,
                            } })) : null),
                    React.createElement("div", { className: "discount-bar__labels" },
                        settings.tier_one_disc && settings.tier_one_qty ? (React.createElement("div", { "data-discount-reached": totalCustomisableProductCount >= settings.tier_one_qty ? true : false },
                            React.createElement("div", null, totalCustomisableProductCount >= settings.tier_one_qty ? React.createElement(UnlockedIcon, null) : React.createElement(LockedIcon, null)),
                            settings.tier_one_disc,
                            "%")) : null,
                        settings.tier_two_enable ? (React.createElement("div", { "data-discount-reached": totalCustomisableProductCount >= settings.tier_two_qty ? true : false },
                            React.createElement("div", null, totalCustomisableProductCount >= settings.tier_two_qty ? React.createElement(UnlockedIcon, null) : React.createElement(LockedIcon, null)),
                            settings.tier_two_disc,
                            "%")) : null,
                        settings.tier_three_enable ? (React.createElement("div", { "data-discount-reached": totalCustomisableProductCount >= settings.tier_three_qty ? true : false },
                            React.createElement("div", null, totalCustomisableProductCount >= settings.tier_three_qty ? React.createElement(UnlockedIcon, null) : React.createElement(LockedIcon, null)),
                            settings.tier_three_disc,
                            "%")) : null)))),
            React.createElement("div", { className: cartState.length > 0
                    ? `th-c-atc-modal__atc-btn`
                    : `th-c-atc-modal__atc-btn th-c-atc-modal__atc-btn--disabled` },
                React.createElement("button", { className: "button button--xl", onClick: addToCart },
                    strings.modal_add_to_cart_final,
                    " ",
                    React.createElement("span", null, price.finalPrice))))));
};
export default AddToCartModal;
